import type {Ref} from "vue";
import {onMounted, onUnmounted} from "vue";

export default class ConfirmationPopup {

    private static instance: ConfirmationPopup;
    private static creating: boolean = false;
    private showRef: Ref<boolean> | null = null;
    private messageRef: Ref<string> | null = null;
    private popupBlock: HTMLElement | null = null;
    private confirmCallback: (() => void) | null = null;
    private boundHandleClickOutside: (event: MouseEvent) => void;
    private hideCallback: (() => void) | null = null;


    private constructor() {
        this.boundHandleClickOutside = this.handleClickOutside.bind(this);
        if (!ConfirmationPopup.creating) {
            throw new Error("You must use ChatCounterService.getInstance() to create an instance.");
        }

    }


    static getInstance(): ConfirmationPopup {
        if (!ConfirmationPopup.instance) {
            ConfirmationPopup.creating = true;
            ConfirmationPopup.instance = new ConfirmationPopup();
            ConfirmationPopup.creating = false;
        }
        return ConfirmationPopup.instance;
    }

    public init(showRef: Ref<boolean>, popupBlock: HTMLElement, messageRef: Ref<string>): void {
        this.showRef = showRef;
        this.popupBlock = popupBlock;
        this.messageRef = messageRef;
        this.hideCallback = null;
    }

    public addHideCallback(callback: () => void): ConfirmationPopup {
        this.hideCallback = callback;
        return this;
    }

    private handleClickOutside(event: MouseEvent): void {
        if (this.isShow() && this.popupBlock && !this.popupBlock.contains(event.target as Node)) {
            this.hide()
        }
    }

    public isShow(): boolean {
        return this.showRef ? this.showRef!.value : false;
    }

    public onConfirm(callback: () => void): ConfirmationPopup {
        this.confirmCallback = callback;
        return this
    }

    public confirm(): void {
        if (this.confirmCallback) {
            this.confirmCallback();
        }
        this.confirmCallback = null;
        this.hide();
    }

    public show(message: string): ConfirmationPopup {
        if (this.showRef) {
            this.showRef.value = true;
        }
        if (this.messageRef) {
            this.messageRef.value = message;
        }
        setTimeout(() => {
            document.addEventListener('click', this.boundHandleClickOutside)
        }, 100);
        return this
    }

    public hide( ): void {
        if (this.hideCallback) {
            this.hideCallback();
        }
        if (this.showRef) {
            this.showRef.value = false;
        }
        document.removeEventListener('click', this.boundHandleClickOutside);
    }
}
